<div class="portal--header">
  <h1 class="heading">Securely logging you out...</h1>
</div>

<div class="portal--main">
  <p>{{message}}</p>
</div>
